import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasNominaDocumentosComprobantedepositoAgregar', {
    template: template,
    controller: NominasNominaDocumentosComprobantedepositoAgregarComponent,
    bindings: {
      onChange: '&',
    },
    require: {
      comprobantedeposito: '^nominasNominaDocumentosComprobantedeposito',
    },
  })

function NominasNominaDocumentosComprobantedepositoAgregarComponent(NominaDocumentosComprobantedeposito, $fileSystem) {
  let $ctrl = this

  $ctrl.$onInit = $onInit
  $ctrl.seleccionar = seleccionar

  function $onInit() {
    $ctrl.idEmpresa = $ctrl.comprobantedeposito.idEmpresa
    $ctrl.idNomina = $ctrl.comprobantedeposito.idNomina
    $ctrl.agregando = false
    $ctrl.accept = 'application/pdf,application/zip,application/x-zip-compressed,application/x-rar-compressed, application/octet-stream'
    $ctrl.file = null
  }

  function agregar(files) {
    $ctrl.agregando = true
    $ctrl.file = files[0]

    NominaDocumentosComprobantedeposito.post($ctrl.idEmpresa, $ctrl.idNomina, $ctrl.file)
      .then(function (response) {
        $ctrl.data = response.data
        $ctrl.onChange({$event: {data: $ctrl.data}})
      })
      .finally(function () {
        $ctrl.agregando = false
      })
  }

  function seleccionar() {
    $fileSystem.select(false, $ctrl.accept)
      .then(agregar)
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/documentos/comprobantedeposito/agregar/componet.js